<template>
  <span class="bg-primary-50 text-primary-500 rounded-md p-1 text-xs">{{
    $t('generic_new_badge')
  }}</span>
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
</script>
